<template>
  <div
    class="audio-container"
    :id="content.key"
  >
    <div class="audio-box">
      <img class="audio-cover" :src="content.cover" alt="">
      <div class="play-btn" @click="audioPlayerShow">
        <i class="icon el-icon-video-play"></i>点击收听音频
      </div>
    </div>
    <div class="audio-title">{{ content.title }}</div>
    <audioPlayer :dialogTitle="dialogTitle" :visible="dialogVisible" :audio_src="content.url" @dialogClose="audioPlayerHide"></audioPlayer>
  </div>
</template>

<script>
/*
单个音频样式 适用于单个显示版型
*/
import audioPlayer from "../../popup/audioPlayer.vue";
export default {
  name: "audioUnit",
  components: {
    audioPlayer
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogTitle: '播放音频',
      dialogVisible: false
    }
  },
  methods: {
    audioPlayerShow() {
      this.dialogVisible = true
    },
    audioPlayerHide() {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.audio-container {
  width: 100%;
  margin: 0 auto 10px;

  .audio-box{
    width: 100%;
    position: relative;

    .audio-cover{
      width: 100%;
      display: block;
    }

    .play-btn{
      position: absolute;
      bottom: 20px;
      right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 30px;
      width: 238px;
      height: 58px;
      color: #00a8ac;
      border: 1px solid #00a8ac;
      background: rgba(7, 170, 174, 0.1);
      cursor: pointer;
  
      i {
        font-size: 26px;
        margin-right: 10px;
      }
    }

    .play-btn:hover {
      background: rgba(7, 170, 174, 0.2);
    }
  }

  .audio-title{
    width: 100%;
    display: inline-block;
    margin-top: 10px;
    color: #00A9AD;
    font-size: 16px;
    text-align: center;
  }
}
</style>